import CIMPowerOptimizationPage from './CIMPowerOptimizationPage';

export default CIMPowerOptimizationPage;
